// Configuracion de las chips que se muestran debajo del mensaje de cada fila.
//
// Para cambiar que informacion aparece, agregar una chip nueva o quitar una,
// solo se edita este arreglo: NotificacionItem las recorre tal cual y no
// conoce ningun campo en particular.
//
// Cada entrada:
//   clave    -> identificador unico (key de React)
//   visible  -> (notificacion) => boolean. Si regresa false, la chip no se pinta.
//   texto    -> (notificacion) => string que se muestra.
//   titulo   -> (notificacion) => string opcional para el tooltip nativo.
//   variante -> "default" | "grupo". Define el estilo en SCSS.

import { obtenerAreaNotificacion } from "./ModulosNotificacionesArray";

export const CHIPS_NOTIFICACION_SISTEMA = [
    {
        clave: "repeticiones",
        visible: (n) => Number(n.repeticiones || 1) > 1,
        texto: (n) => `x${n.repeticiones}`,
        titulo: (n) => `Este aviso se recibio ${n.repeticiones} veces`,
        variante: "grupo",
    },
    {
        clave: "folio",
        visible: (n) => !!n.parametro,
        texto: (n) => `Folio ${n.parametro}`,
        variante: "default",
    },
    {
        clave: "area",
        visible: (n) => !!n.portafolio,
        texto: (n) => obtenerAreaNotificacion(n.portafolio).etiqueta,
        variante: "default",
    },
];

export const CHIPS_NOTIFICACION_WHATSAPP = [
    {
        clave: "mensajes",
        visible: (n) => Number(n.repeticiones || 1) > 1,
        texto: (n) => `${n.repeticiones} mensajes`,
        titulo: () => "Abre el chat para leer la conversacion completa",
        variante: "grupo",
    },
    {
        clave: "telefono",
        visible: (n) => !!n.numeroTelefono,
        texto: (n) => n.numeroTelefono,
        variante: "default",
    },
];
